import { defineComponent } from "vue";

export default defineComponent({
    template: `
        <div class="OfferLoader">
            <svg width="91" height="107" viewBox="0 0 91 107" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M50.6218 3.5L6.08909 56.9393C4.34504 59.0321 3.47302 60.0785 3.4597 60.9623C3.44811 61.7306 3.79046 62.4615 4.38809 62.9445C5.07555 63.5 6.43769 63.5 9.16198 63.5H45.6218L40.6218 103.5L85.1545 50.0607C86.8986 47.9679 87.7706 46.9215 87.7839 46.0377C87.7955 45.2694 87.4531 44.5385 86.8555 44.0555C86.1681 43.5 84.8059 43.5 82.0816 43.5H45.6218L50.6218 3.5Z" stroke="#2CB34A" stroke-width="6" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </div>
    `,
});
